"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./avatar.scss");
const svgIcons_1 = require("../../../../svgIcons");
const Avatar = (props) => {
    return (react_1.default.createElement("div", { className: `avatar-wrapper ${props.className}` },
        props.unread > 0 && react_1.default.createElement("span", { className: 'unread-msg' }, props.unread),
        props.imageUrl ? react_1.default.createElement("img", { src: props.imageUrl })
            : react_1.default.createElement(svgIcons_1.AvatarIcon, { className: 'avatar', style: { fontSize: '22px' } })));
};
exports.default = Avatar;
